import { Button, EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import FileUploader from 'react-firebase-file-uploader'
import Lightbox from 'react-image-lightbox'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Dispatch, RootState } from '../../store'
import Avatar from '../Avatar'
import buttonStyles from '../Button/button.scss'
import dragStyles from '../Drag/drag.scss'
import Icon from '../Icon'
import materialStyles from '../Material/material.scss'
import messageStyles from '../Message/message.scss'
import ReplyItem from '../ReplyItem'
import TextInput from '../TextInput/textArea'

// import TextInput from '../TextInput/'
import styles from './material-item.scss'

const cx = classnames.bind({
  ...styles,
  ...dragStyles,
  ...buttonStyles,
  ...messageStyles,
  ...materialStyles
})

type IProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  RouteComponentProps<any> & {
    id: string;
    expanded: boolean;
    editable: boolean;
    lectureId: string;
    insightId: string;
    materialIdx: number;
    material: IMaterial;
    currentLecture: ILecture | null;
    onExpand?: () => void;
    onLoaded?: () => void;
    onStarted?: () => void;
    onEnded?: () => void;
    onReactionToggle?: () => void;
    onConfirm?: (material: IMaterial) => void;
    onDelete?: () => void;
    onReply?: (reply: IReply) => void;
  }

class MaterialItem extends React.PureComponent<IProps> {
  public state = {
    expanded: this.props.expanded,
    editing: false,
    isUploading: false,
    progress: 0,
    filename: '',
    material: this.props.material,
    replyText: '',
    lightboxIsOpen: false,
    isExpendedSetByProps: false
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    const { isExpendedSetByProps } = this.state
    if (!isExpendedSetByProps) {
      if (nextProps.expanded) {
        this.setState({ isExpendedSetByProps: true })
      }
      if (nextProps.expanded !== undefined) {
        this.setState({ expanded: nextProps.expanded })
      }
    }
  }
  public handleConfirmClick = () => {
    const { onConfirm } = this.props
    const { material } = this.state
    if (onConfirm) {
      onConfirm(material)
    }
    this.handleEditToggle()
  }
  public handleReplyChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    this.setState({ replyText: event.currentTarget.value })
  }
  public handleReplySubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const currentUser = firebase.auth().currentUser
    if (currentUser === null) {
      throw Error('請先登入會員')
    }
    const reply: IReply = {
      ts: firebase.firestore.Timestamp.now(),
      text: `${this.state.replyText.replace(/(?:\r\n|\r|\n)/g, '\n')}`,
      reactions: {
        like: []
      },
      revisions: [],
      replierId: currentUser.uid
    }

    if (this.props.onReply) {
      this.props.onReply(reply)
    }
    this.setState({ replyText: '' })
  }
  public handleMaterialNameSave = (name: string) => {
    const { material } = this.state
    this.setState({ material: { ...material, name } })
  }
  public handleMaterialUrlSave = (downloadUrl: string) => {
    const { material } = this.state
    this.setState({ material: { ...material, downloadUrl } })
  }
  public handleEditToggle = () => {
    this.setState({ editing: !this.state.editing })
  }
  public handleDeleteClick = () => {
    if (this.props.onDelete) {
      this.props.onDelete()
    }
  }

  public handleExpandToggle = () => {
    const { history, lectureId, insightId, materialIdx } = this.props
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
    history.push(
      `/lectures/${lectureId}?insightId=${insightId}&materialIdx=${materialIdx}`
    )
  }

  public handleUploadStart = () =>
    this.setState({ isUploading: true, progress: 0 })
  public handleProgress = (progress: number) => this.setState({ progress })
  public handleUploadError = (error: Error) => {
    this.setState({ isUploading: false })
  }
  public handleUploadSuccess = async (filename: string) => {
    const currentUser = firebase.auth().currentUser
    this.setState({ filename, progress: 100, isUploading: false })
    if (currentUser === null) {
      throw Error('請先登入會員')
    }
    const ref = firebase
      .storage()
      .ref(currentUser.uid)
      .child(filename)
    const metadata = await ref.getMetadata()
    R.keys(metadata).forEach(key => {
      if (metadata[key] === undefined) {
        delete metadata[key]
      }
    })
    const updatedMaterial: IMaterial = {
      ...this.state.material,
      metadata,
      downloadUrl: await ref.getDownloadURL()
    }
    this.setState({ material: updatedMaterial })
  }
  public openLightbox = () => {
    this.setState({
      lightboxIsOpen: true
    })
  }
  public closeLightbox = () => {
    this.setState({
      lightboxIsOpen: false
    })
  }
  public render() {
    const { expanded } = this.state
    const {
      currentLecture,
      editable,
      material,
      onReactionToggle,
      lectureId,
      insightId,
      materialIdx,
      id,
      onAuthModalOpen
    } = this.props
    const currentUser = firebase.auth().currentUser
    const activeLike = currentUser
      ? R.contains(currentUser.uid, material.reactions.like)
      : false
    // TODO: active reply or not
    const activeReply = false

    return (
      <div className={cx('message-item', { active: expanded })} id={id}>
        <div className={cx('message-item__inner')}>
          <div className={cx('message-item__info')}>
            {editable ? (
              <span>
                <Button icon="edit" onClick={this.handleEditToggle} />
                <Button icon="trash" onClick={this.handleDeleteClick} />
              </span>
            ) : null}
            <div className={cx('message-item__content')}>
              {this.renderMaterial()}
            </div>
            <div className={cx('message-item__footer')}>
              <div
                onClick={onReactionToggle}
                className={cx('message-item__like', { active: activeLike })}
              >
                <span>{material.reactions.like.length}</span>
                <span>喜歡</span>
              </div>
              <div
                onClick={this.handleExpandToggle}
                className={cx('message-item__comment', {
                  active: activeReply
                })}
              >
                {currentLecture &&
                new Date() >= currentLecture.startedAt.toDate() ? (
                  <span>{material.replyIds.length}</span>
                ) : null}
                <span>討論</span>
              </div>
            </div>
          </div>
        </div>
        {expanded ? (
          currentLecture && new Date() >= currentLecture.startedAt.toDate() ? (
            <div>
              <div className={cx('message-item__comment-board')}>
                <hr />
                <div className={cx('message-item__comment-list')}>
                  {material.replyIds.map(replyId => (
                    <ReplyItem
                      key={replyId}
                      lectureId={lectureId}
                      insightId={insightId}
                      materialIdx={materialIdx}
                      replyId={replyId}
                    />
                  ))}
                </div>
                <hr />
                {currentUser !== null ? (
                  <div className={cx('message-item__comment-form')}>
                    <div className={cx('message-item__avatar')}>
                      <Avatar
                        userId={currentUser ? currentUser.uid : undefined}
                      />
                    </div>
                    <form action="" onSubmit={this.handleReplySubmit}>
                      <TextInput
                        disabled={currentUser === null}
                        onChange={this.handleReplyChange}
                        value={this.state.replyText}
                        rows={4}
                        // type="text"
                        style={{
                          lineHeight: `24px`,
                          height: `44px`,
                          padding: `8px 5px 5px`
                        }}
                        placeholder="留言..."
                        className={cx('message-item__comment-input')}
                      />
                      <input
                        type="submit"
                        value="送出"
                        disabled={currentUser === null}
                        className={cx('btn', 'btn--primary', 'btn--lg')}
                      />
                    </form>
                  </div>
                ) : (
                  <div className={cx('message-item__login-tection')}>
                    <h4>
                      <a href="#!" onClick={onAuthModalOpen}>
                        登入
                      </a>{' '}
                      即可參與討論
                    </h4>
                  </div>
                )}
                {/* <p className={cx('message-item__description', 'para--sm')}>Shift + Enter 文字可換行</p> */}
                <p className={cx('message-item__description', 'para--sm')} />
              </div>
              <a
                className={cx('message-item__close')}
                onClick={this.handleExpandToggle}
              >
                <Icon type="lecture-droptop" />
                完成
              </a>
            </div>
          ) : (
            <div className={cx('message-item__login-tection')}>
              <h4>講座開始後開放討論</h4>
            </div>
          )
        ) : null}
      </div>
    )
  }
  public renderMaterial = () => {
    const { editing, material } = this.state
    const {
      onEnded,
      onStarted,
      lectureContent,
      insightId,
      materialIdx
    } = this.props
    const type = material.metadata.contentType
      ? R.split('/')(material.metadata.contentType)[0]
      : null
    const currentUser = firebase.auth().currentUser
    const active =
      lectureContent.currentInsightId === insightId &&
      lectureContent.currentMaterialIdx === materialIdx
    switch (type) {
      case 'image':
        if (active && onEnded) {
          onEnded()
        }
        if (editing) {
          if (currentUser === null) {
            return '無法編輯'
          }
          return (
            <div className={cx('drag-item', 'drag-item--edit')}>
              <EditableText
                defaultValue={material.name}
                placeholder="請輸入圖片說明標題(選填)"
                onConfirm={this.handleMaterialNameSave}
              />
              <div className={cx('drag-item__content')}>
                {material.downloadUrl ? (
                  <img src={material.downloadUrl} alt="" />
                ) : (
                  <p className={cx('para')}>支援 .jpg .png 檔案</p>
                )}
              </div>
              <div className={cx('drag-item__edit-btns')}>
                <label className={cx('btn', 'btn--md', 'btn--primary')}>
                  {material.downloadUrl ? '重新上傳' : '上傳'}
                  <FileUploader
                    hidden={true}
                    accept="image/*"
                    storageRef={firebase.storage().ref(currentUser.uid)}
                    onUploadStart={this.handleUploadStart}
                    onUploadError={this.handleUploadError}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                  />
                </label>
                <span>
                  {this.state.isUploading && (
                    <p>上傳中: {this.state.progress} %</p>
                  )}
                </span>
                <button
                  className={cx('drag-item__comfirm-btn')}
                  title="確認"
                  onClick={this.handleConfirmClick}
                >
                  <Icon type="lecture-droptop" />
                  確認
                </button>
              </div>
            </div>
          )
        }
        return material.downloadUrl ? (
          <div className={cx('bubble')}>
            <div className={cx('pic-group')}>
              {material.name === '' ? null : (
                <div className={cx('title')}>{material.name}</div>
              )}
              <img
                onClick={this.openLightbox}
                src={material.downloadUrl}
                alt=""
              />
              {
                this.state.lightboxIsOpen && <Lightbox
                  mainSrc={material.downloadUrl}
                  onCloseRequest={this.closeLightbox}
                />
              }

            </div>
          </div>
        ) : (
          <p className={cx('para')}>無圖片檔案</p>
        )
      case 'audio':
        if (editing) {
          if (currentUser === null) {
            return '無法編輯'
          }
          return (
            <div className={cx('drag-item', 'drag-item--edit')}>
              <EditableText
                defaultValue={material.name}
                placeholder="請輸入音檔說明標題(選填)"
                onConfirm={this.handleMaterialNameSave}
              />
              <div className={cx('drag-item__content')}>
                {material.downloadUrl ? (
                  <div className={cx('audio')}>
                    <audio controls={true} controlsList="nodownload">
                      <source src={material.downloadUrl} />
                    </audio>
                  </div>
                ) : (
                  <p className={cx('para')}>支援 .mp4 .wmv .m4a 檔案</p>
                )}
              </div>
              <div className={cx('drag-item__edit-btns')}>
                <label className={cx('btn', 'btn--md', 'btn--primary')}>
                  {material.downloadUrl ? '重新上傳' : '上傳'}
                  <FileUploader
                    hidden={true}
                    accept="audio/*"
                    storageRef={firebase.storage().ref(currentUser.uid)}
                    onUploadStart={this.handleUploadStart}
                    onUploadError={this.handleUploadError}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                  />
                </label>
                <span>
                  {this.state.isUploading && (
                    <p>上傳中: {this.state.progress} %</p>
                  )}
                </span>
                <button
                  className={cx('drag-item__comfirm-btn')}
                  title="確認"
                  onClick={this.handleConfirmClick}
                >
                  <Icon type="lecture-droptop" />
                  確認
                </button>
              </div>
            </div>
          )
        }
        return material.downloadUrl ? (
          <div className={cx('bubble')}>
            <div className={cx('audio-group')}>
              {material.name === '' ? null : (
                <div className={cx('title')}>{material.name}</div>
              )}
              <div className={cx('audio')}>
                <audio
                  controls={true}
                  controlsList="nodownload"
                  ref={ref => {
                    if (ref && active && ref.paused) {
                      ref.play()
                    }
                    if (ref && !active) {
                      ref.pause()
                      ref.currentTime = 0
                    }
                  }}
                  onEnded={onEnded}
                  onPlay={onStarted}
                >
                  <source src={material.downloadUrl} />
                </audio>
              </div>
            </div>
          </div>
        ) : (
          <p className={cx('para')}>無聲音檔案</p>
        )
      case 'text':
        if (active && onEnded) {
          onEnded()
        }
        if (editing) {
          if (currentUser === null) {
            return '無法編輯'
          }
          return (
            <div className={cx('drag-item', 'drag-item--edit')}>
              <EditableText
                defaultValue={material.name}
                placeholder="請輸入連結標題(選填)"
                onConfirm={this.handleMaterialNameSave}
              />
              <div className={cx('drag-item__group')}>
                <EditableText
                  defaultValue={material.downloadUrl || ''}
                  placeholder="https://"
                  onConfirm={this.handleMaterialUrlSave}
                />
                <Icon type="edit-link" />
              </div>
              <div className={cx('drag-item__edit-btns')}>
                <button
                  className={cx('drag-item__comfirm-btn')}
                  title="確認"
                  onClick={this.handleConfirmClick}
                >
                  <Icon type="lecture-droptop" />
                  確認
                </button>
              </div>
            </div>
          )
        }
        return material.downloadUrl ? (
          <p className={cx('para')}>
            <a
              className={cx('link')}
              target="_blank"
              rel="noopener noreferrer"
              href={material.downloadUrl}
            >
              {material.name}
            </a>
          </p>
        ) : (
          <p className={cx('para')}>無連結</p>
        )
      default:
        if (active && onEnded) {
          onEnded()
        }
        return <p className={cx('para')}>不支援此檔案格式</p>
    }
  }
}

const mapState = ({ insights, replies, lectureContent, auth }: RootState) => ({
  replies,
  insights,
  lectureContent,
  showAuthModal: auth.showAuthModal
})

const mapDispatch = (dispatch: Dispatch) => ({
  onAuthModalOpen: () => dispatch.auth.openAuthModal()
})

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(MaterialItem)
)



// WEBPACK FOOTER //
// ./src/components/MaterialItem/index.tsx